<template>
  <div class="max-h-[98vh]" :key="pageTitle">
    <PageTitleVue 
      :sub-title="subTitle" 
      :key="subTitle"
      :small="pageTitle == 'SISTEMA DE EMERGÊNCIA' ? true : false"
    >
      {{ pageTitle }}

      <!-- go back button -->
      <template #action>
        <div
          class="cursor-pointer text-gray-400"
          :key="backPage"
          v-if="
            dataExtinguisher.state.componentActive.__name !== 'SectorsCards' &&
            dataExtinguisher.state.componentActive.__name !== 'SectorForm' &&
            dataExtinguisher.state.componentActive.__name !== 'SectorFormUpdate'
          "
        >
          <p class="flex" @click="setBackComponent()">
            <component
              :is="PhArrowLeft"
              class="w-7 h-7 p-1"
            />
            <p class="my-auto">voltar</p>
          </p>
        </div>
      </template>

      <template #b-action>
        <div v-if="buttonActive">
          <Create
            :icon="PhFactory"
            :label="'Cadastrar Setor'"
            :width-maximus="true"
            @click="setComponentActive(SectorForm)"
            v-if="dataExtinguisher.state.componentActive.__name == 'SectorsCards'"
          />

          <Create
            :icon="PhFireExtinguisher"
            :label="'Novo item'"
            :width-maximus="false"
            @click="setComponentActive(RegisterItemForm)"
            v-else-if="dataExtinguisher.state.componentActive.__name == 'SectorsList'"
          />

          <Create
            :icon="PhArrowLeft"
            :label="'Voltar aos setores'"
            :width-maximus-plus="true"
            @click="setComponentActive(SectorsCards)"
            v-else-if="dataExtinguisher.state.componentActive.__name == 'SectorForm'"
          />

          <Create
            :icon="PhArrowLeft"
            :label="'Voltar aos setores'"
            :width-maximus-plus="true"
            @click="setComponentActive(SectorsCards)"
            v-else-if="dataExtinguisher.state.componentActive.__name == 'SectorFormUpdate'"
          />
        </div>
      </template>
    </PageTitleVue>

    <Transition mode="out-in">
      <div :key="componentActive" class="overflow-hidden">
        <keep-alive>
          <component :is="componentActive"/>
        </keep-alive>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import RegisterItemForm from "./layout/pages/RegisterItemForm.vue";
import PageTitleVue from "@/components/Titles/PageTitle.vue";
import SectorsCards from "./layout/pages/SectorsCards.vue";
import SectorsList from "./layout/pages/SectorsList.vue";
import ExtinguisherService from "./service/extinguisher.service";
import Create from "@/components/Buttons/Create.vue";
import SectorForm from "./layout/SectorForm.vue";
import { PhArrowLeft, PhFactory, PhFireExtinguisher } from "@phosphor-icons/vue";
import { onBeforeMount } from "vue";
import { storeApp } from "@/store";
import { dataExtinguisher } from "./store";
import { computed } from "vue";
import { markRaw } from "vue";

const componentActive = computed(() => markRaw(dataExtinguisher.getters.getActiveComponent));
const buttonActive = computed(() => dataExtinguisher.getters.getIfButtonActive);
const subTitle = computed(() => dataExtinguisher.getters.getPageSubTitle);
const backPage = computed(() => dataExtinguisher.getters.backToComponent);

const pageTitle = computed(() => {
  if(dataExtinguisher.state.componentActive.__name == 'SectorsCards') {
    dataExtinguisher.dispatch("setPageTitle", "SISTEMA DE EMERGÊNCIA");
    dataExtinguisher.dispatch("setPageSubTitle", "Gerencie seus sistema de emergência com facilidade");
  }

  if(dataExtinguisher.state.componentActive.__name == 'SectorForm') {
    dataExtinguisher.dispatch("setPageTitle", "NOVO SETOR");
    dataExtinguisher.dispatch("setPageSubTitle", "Faça o cadastro de um novo setor para gerenciar seus itens");
  }

  if(dataExtinguisher.state.componentActive.__name == 'SectorsList') {
    dataExtinguisher.dispatch("setPageSubTitle", "Monitore todos os itens deste setor");
  }

  if(dataExtinguisher.state.componentActive.__name == 'RegisterItemForm') {
    dataExtinguisher.dispatch("setPageSubTitle", "Cadastre um novo item para monitorar neste setor");
  }

  if(dataExtinguisher.state.componentActive.__name == 'UpdateAndMaintenanceForm') {
    dataExtinguisher.dispatch("setPageSubTitle", "Atualize os dados deste item e registre novas manutenções de maneira fácil");
  }
  
  return dataExtinguisher.getters.getTitle
});

onBeforeMount(async () => {
  storeApp.state.loading = true;
  dataExtinguisher.dispatch("setComponentActive", markRaw(SectorsCards));
  dataExtinguisher.dispatch("setBackComponent", "SectorsCards");
  await getSectors();
  storeApp.state.loading = false;
});

function setComponentActive(value) {
  dataExtinguisher.dispatch('resetForm')
  dataExtinguisher.dispatch("setComponentActive", markRaw(value));
}

function setBackComponent() {
  if (dataExtinguisher.state.componentActive.__name == "SectorsList") {
    setComponentActive(SectorsCards);
  }

  if (dataExtinguisher.state.componentActive.__name == "UpdateAndMaintenanceForm") {
    setComponentActive(SectorsList);
  }

  if (dataExtinguisher.state.componentActive.__name == "RegisterItemForm") {
    setComponentActive(SectorsList);
  }
}

async function getSectors() {
  await ExtinguisherService.getSectors()
    .then((res) => {
      dataExtinguisher.dispatch("setAllSectors", res.data);
    })
    .catch((err) => {
      console.log(err);
    });
}

</script>

<style lang="scss">
::v-deep .v-enter-from,
::v-deep .v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

::v-deep .v-enter-active,
::v-deep .v-leave-active {
  transition: all 0.3s;
}
</style>
